function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSiteCoreTerrestrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 19.84375 19.84375",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    style: {
      display: "inline"
    },
    transform: "translate(0,-6.6145833)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.20578703,
      strokeOpacity: 1
    },
    id: "rect4518-85",
    width: 19.84375,
    height: 19.84375,
    x: 0,
    y: 6.6145835
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#472a0f",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.17834875,
      strokeOpacity: 1
    },
    id: "rect4518-8-4",
    width: 17.197916,
    height: 17.197916,
    x: 1.3229166,
    y: 7.9375005
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.23597811,
      strokeOpacity: 1
    },
    d: "m 10.755544,12.677556 c -0.8411217,0 -2.1719885,2.265172 -2.173511,2.782387 -0.0015,0.517215 1.557048,1.67028 1.557048,2.017598 0,0.34731 -0.03874,0.657045 -0.4749435,0.657045 -0.4361955,0 -1.9590142,-3.09711 -2.4200068,-3.097095 -0.4609927,1.5e-5 -3.6982821,3.459892 -3.2753811,4.19238 0.4229009,0.73248 11.5916314,0.544927 11.9062484,0 0.314618,-0.544935 -4.278333,-6.552315 -5.119454,-6.552315 z",
    id: "rect4563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSiteCoreTerrestrial);
export default __webpack_public_path__ + "static/media/icon-site-core-terrestrial.d4cd63a4552ceb9c7808a9ee614ed124.svg";
export { ForwardRef as ReactComponent };